import { paths } from "../i18n/paths";
import { useI18n } from "../i18n/I18nProvider";

/** Frames 0:1029 and 0:1045: mark, copy and button, 28 desktop and 24 mobile between blocks. */
export function SuccessView({ animate }: { animate: boolean }) {
  const { copy, locale } = useI18n();
  const t = copy.success;

  return (
    <div className="flex flex-1 flex-col items-center justify-center px-6 py-12 text-center">
      <div className={animate ? "reveal-mark" : undefined}>
        <span className="relative flex h-40 w-40 items-center justify-center rounded-full bg-success-halo/60 lg:h-[196px] lg:w-[196px]">
          <span className="flex h-[124px] w-[124px] items-center justify-center rounded-full bg-success lg:h-[154px] lg:w-[154px]">
            <CheckGlyph />
          </span>
        </span>
      </div>
      <div className={`flex flex-col items-center ${animate ? "reveal-copy" : ""}`}>
        <div className="mt-6 flex flex-col items-center gap-2.5 lg:mt-7 lg:gap-3">
          <h1 className="text-[25px] font-bold leading-tight text-navy lg:text-[40px]">
            {t.heading}
          </h1>
          <p className="whitespace-pre-line text-[13px] leading-relaxed text-body lg:text-[17px]">
            {t.message}
          </p>
        </div>
        <a
          href={paths[locale].home}
          className="gradient-cta mt-6 inline-flex h-[54px] w-[302px] max-w-full items-center justify-center rounded-xl text-[15px] font-bold text-white shadow-card lg:mt-7 lg:h-[58px] lg:w-[300px]"
        >
          {t.backHome}
        </a>
      </div>
    </div>
  );
}

function CheckGlyph() {
  return (
    <svg
      viewBox="0 0 124 124"
      width="124"
      height="124"
      aria-hidden="true"
      className="h-[100px] w-[100px] lg:h-[124px] lg:w-[124px]"
    >
      <path
        d="M27 64.5 52.5 90 97 45.5"
        fill="none"
        stroke="#ffffff"
        strokeWidth="11"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
